export enum FrankieOneVerificationStatus {
  FAIL = 'FAIL',
  PASS = 'PASS',
  REFER = 'REFER',
  NONE = 'NONE',
  UNCHECKED = 'UNCHECKED',
}
